import React from "react";

const AlumniLine = ({color = "currentColor"}) => (
    <svg width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 27">
        <g stroke={color} fill="none" fillRule="evenodd">
            <g strokeLinecap="round" strokeLinejoin="round">
                <path d="M13.094 16.825c1.537 0 5.12-1.966 5.12-4.915 1.537 0 1.537-2.948 0-2.948l-.511-2.458c-4.097 0-4.097-1.474-4.609-1.966-.512.492-.512 1.966-4.608 1.966l-.512 2.458c-1.536 0-1.536 2.948 0 2.948 0 2.949 3.584 4.915 5.12 4.915z" />
                <path d="M19.228 9.7l.523-3.687s.512-4.915-6.657-4.915c-7.168 0-6.656 4.915-6.656 4.915L6.962 9.7M10.49 15.856l-6.513 1.71c-1.6.576-2.66 2.042-2.66 3.682v2.457h15.43" />
                <path d="M10.022 9.946c0-.543.458-.491 1.024-.491.567 0 1.024-.052 1.024.491M14.118 9.946c0-.543.458-.491 1.025-.491.566 0 1.024-.052 1.024.491" />
            </g>
            <g transform="translate(16.747 12)">
                <rect strokeWidth=".8" x="7.471" y="7.608" width="1.624" height="2.901" rx=".6" />
                <path
                    d="M6.175 2.712h4.217l-.296-1.62A.6.6 0 009.506.6H7.062a.6.6 0 00-.59.492l-.297 1.62zM7.244 8.75V7.365h2.08V8.75h3.996a.8.8 0 00.763-.558l1.335-4.213a.8.8 0 00-.763-1.041H1.912a.8.8 0 00-.762 1.041l1.335 4.213a.8.8 0 00.762.559l3.997-.001z"
                    strokeWidth="1.2"
                />
                <rect x=".5" y="2.838" width="15.567" height="11.662" rx="1.2" />
            </g>
        </g>
    </svg>
);

export default AlumniLine;
